module.exports = __webpack_public_path__ + "img/slide_arrow.c74df1bc.svg";